import styled from "styled-components";

export const Title = styled.h1`
  justify-content: center;
  margin-bottom: 10px;
  font-size: 40px;
  align-self: center;
  max-width: max-content;
  cursor: pointer;

  @media (max-width: 760px) {
    cursor: none;
  }
`

